import Survey from "../surveyjs/SurveyCompiler";

function Test() {
	return (
		<div>
			<div>ciao</div>
			<Survey />
		</div>
	);
}

export default Test;
